import { axios } from '../../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import styles from '../account.module.css';
import fileDownload from 'js-file-download';
import { Button, Pagination, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getAxiosConfig } from '../../utils/apiUtils';
import { getLoggedInUser } from '../../utils/authUtils';

moment.locale('es');
moment.lang('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
  weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
  weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
}
);

const Invoices = () => {
  const { t, i18n } = useTranslation();
  const [activePage, setActivePage] = useState(1);
  const [subscription, setSubscription] = useState();
  const [customer, setCustomer] = useState();

  const refreshSubscription = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/subscription/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((subscriptionResponse) => {
        setSubscription(subscriptionResponse.data);
      })
      .catch((subscriptionError) => {
        console.debug(subscriptionError);
      });
  };

  const refreshCustomer = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/customer/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((customerResponse) => {
        setCustomer(customerResponse.data);
      })
      .catch((customerError) => {
        console.debug(customerError);
      });
  };

  const handleInvoiceDownload = (invoiceId) => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/invoice/${invoiceId}`,
      {
        ...getAxiosConfig(),
        responseType: 'blob',
      }
    )
      .then((invoiceResponse) => {
        fileDownload(invoiceResponse.data, `boleta_chungungo_${invoiceId}.pdf`);
      })
      .catch((invoiceError) => {
        console.debug("Error downloading invoice");
      });
  };

  useEffect(
    () => {
      refreshSubscription();
      refreshCustomer();
    },
    []
  );

  const items = [];

  for (let number = 1; number <= (subscription && subscription.invoices ? Math.ceil(subscription.invoices.length / 12) : 0); number++) {
    items.push(
      <Pagination.Item key={number} active={number === activePage}>
        {number}
      </Pagination.Item>,
    );
  }

  return (
    <section className="info-relevante">
      <div class="container"
        style={{paddingLeft: 32}}
      >
        <div class="row py-5">
          <div class="breadcrumb1 col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb p-0">
                <li class="breadcrumb-item">
                  <a href="/seasons">Home</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/account">{t('account.title')}</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Facturaciones
                </li>
              </ol>
            </nav>
          </div>
          <div class="row" style={{
            width: '100%'
          }}>
            <div class="col-md-12">
              <div className={`row ${styles.payment}`}>
                <div class="col-lg-7 mb-4 mb-lg-0">
                  <div class="d-flex justify-content-between align-items-end mb-4">
                    <h2 class="m-0">Facturaciones</h2>
                  </div>
                </div>
              </div>
              <div>
                <Table responsive hover className="payment">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Descripción</th>
                      <th>Estado</th>
                      <th>Factura/Boleta</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscription && subscription.invoices &&
                      subscription.invoices.slice((activePage - 1) * 12, 12).map(
                        invoice => (
                          <tr>
                            <td className="align-middle">{moment(invoice.createdAt).format('MMMM D, YYYY')}</td>
                            <td className="align-middle">{subscription.plan_name}</td>
                            <td className="align-middle"><span class={invoice.status === 1 ? 'text-success' : 'text-danger'}>{invoice.status === 1 ? 'Pagada' : 'Pendiente de pago'}</span></td>
                            <td className="align-middle"><Button variant="invisible" style={{color:"blue", height: 'auto'}} onClick={() => handleInvoiceDownload(invoice.id)}>Descargar</Button></td>
                          </tr>
                        )
                      )
                    }
                  </tbody>
                </Table>
                <Pagination>
                  <Pagination.Prev>Anterior</Pagination.Prev>
                  {items}
                  <Pagination.Next>Siguiente</Pagination.Next>
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Invoices;